module.exports = __webpack_public_path__ + "static/media/arrow-right.04c75c08.svg";